<template>
  <div>
    <div class="left_pic"></div>
    <div class="right_pic"></div>
    <div class="bottom_pic"></div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang='scss' scoped>
    .left_pic{
        height: 100%;
        width: .9375rem;
        background: url('@/assets/img/left.png') no-repeat center center;
        background-size: 100% 100%;
        position: fixed;
        top: 0;
        left: 0;
    }
    .right_pic{
        height: 100%;
        width: .9375rem;
        background: url('@/assets/img/right.png') no-repeat center center;
        background-size: 100% 100%;
        position: fixed;
        top: 0;
        right: 0;
    }
    .bottom_pic{
        width: 100%;
        height: .9375rem;
        background: url('@/assets/img/bottom.png') no-repeat center center;
        background-size: 100% 100%;
        position: fixed;
        bottom: .0625rem;
        left: 0;
    }

</style>